(function () {
  if (window.__langSwitcherInjected) return;
  window.__langSwitcherInjected = true;

  var LANGUAGES = [
    { code: 'es', path: '/', flag: 'es', name: 'Espa\u00f1ol', match: function (p) { return p === '/' || p === '' || !/^\/(en|fr|de)\//.test(p); } },
    { code: 'en', path: '/en/', flag: 'gb', name: 'English', match: function (p) { return /^\/en\//.test(p); } },
    { code: 'fr', path: '/fr/', flag: 'fr', name: 'Fran\u00e7ais', match: function (p) { return /^\/fr\//.test(p); } },
    { code: 'de', path: '/de/', flag: 'de', name: 'Deutsch', match: function (p) { return /^\/de\//.test(p); } }
  ];

  function getCurrentLang() {
    var path = window.location.pathname;
    for (var i = 0; i < LANGUAGES.length; i++) {
      if (LANGUAGES[i].match(path)) return LANGUAGES[i];
    }
    return LANGUAGES[0];
  }

  function injectStyles() {
    var css = '.language-switcher{position:fixed;top:90px;right:20px;z-index:1000}.lang-toggle-btn{width:56px;height:56px;border-radius:50%;background:linear-gradient(135deg,rgba(255,255,255,0.95),rgba(255,255,255,0.85));-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);border:2px solid rgba(236,72,153,0.22);display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 8px 24px rgba(0,0,0,0.12);transition:all 0.3s cubic-bezier(0.4,0,0.2,1);padding:0}.lang-toggle-btn:hover{transform:scale(1.08);box-shadow:0 12px 32px rgba(236,72,153,0.25);border-color:#ec4899}.lang-flag{width:32px;height:32px;display:flex;align-items:center;justify-content:center;border-radius:50%;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.1)}.lang-flag img{width:100%;height:100%;object-fit:cover;display:block}.lang-dropdown{position:absolute;top:70px;right:0;background:linear-gradient(135deg,rgba(255,255,255,0.98),rgba(248,250,252,0.95));-webkit-backdrop-filter:blur(16px);backdrop-filter:blur(16px);border-radius:16px;padding:12px;min-width:200px;box-shadow:0 16px 48px rgba(0,0,0,0.15);border:1px solid rgba(236,72,153,0.16);opacity:0;visibility:hidden;transform:translateY(-10px) scale(0.95);transition:all 0.35s cubic-bezier(0.4,0,0.2,1)}.language-switcher.active .lang-dropdown{opacity:1;visibility:visible;transform:translateY(0) scale(1)}.lang-option{display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:10px;cursor:pointer;transition:all 0.25s ease;color:#1f2937;font-weight:600;text-decoration:none}.lang-option:hover{background:linear-gradient(135deg,rgba(236,72,153,0.08),rgba(244,114,182,0.08));transform:translateX(4px)}.lang-option.active{background:linear-gradient(135deg,rgba(236,72,153,0.12),rgba(244,114,182,0.12));border-left:3px solid #ec4899}.lang-name{font-size:0.95rem;white-space:nowrap}@media (max-width:768px){.language-switcher{top:80px;right:12px}.lang-toggle-btn{width:50px;height:50px}.lang-dropdown{min-width:180px}}';
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function createSwitcher() {
    if (document.getElementById('langSwitcher')) return;
    var current = getCurrentLang();
    var wrapper = document.createElement('div');
    wrapper.className = 'language-switcher';
    wrapper.id = 'langSwitcher';
    var btn = document.createElement('button');
    btn.className = 'lang-toggle-btn';
    btn.setAttribute('aria-label', 'Cambiar idioma');
    var flagSpan = document.createElement('span');
    flagSpan.className = 'lang-flag';
    var img = document.createElement('img');
    img.src = 'https://flagcdn.com/w40/' + current.flag + '.png';
    img.alt = current.code.toUpperCase();
    img.width = 32;
    img.height = 32;
    flagSpan.appendChild(img);
    btn.appendChild(flagSpan);
    wrapper.appendChild(btn);
    var dropdown = document.createElement('div');
    dropdown.className = 'lang-dropdown';
    for (var i = 0; i < LANGUAGES.length; i++) {
      var lang = LANGUAGES[i];
      var a = document.createElement('a');
      a.href = lang.path;
      a.className = 'lang-option' + (lang.code === current.code ? ' active' : '');
      var spanFlag = document.createElement('span');
      spanFlag.className = 'lang-flag';
      var imgFlag = document.createElement('img');
      imgFlag.src = 'https://flagcdn.com/w40/' + lang.flag + '.png';
      imgFlag.alt = lang.code.toUpperCase();
      imgFlag.width = 32;
      imgFlag.height = 32;
      spanFlag.appendChild(imgFlag);
      var spanName = document.createElement('span');
      spanName.className = 'lang-name';
      spanName.textContent = lang.name;
      a.appendChild(spanFlag);
      a.appendChild(spanName);
      dropdown.appendChild(a);
    }
    wrapper.appendChild(dropdown);
    document.body.appendChild(wrapper);
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      wrapper.classList.toggle('active');
    });
    document.addEventListener('click', function () {
      wrapper.classList.remove('active');
    });
    dropdown.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  function setup() {
    // Skip if page already has an inline language switcher
    if (document.getElementById('langSwitcher')) return;
    injectStyles();
    createSwitcher();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
